import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Typography, Button, IconButton } from '@sweep-io/sweep-design';
import { Search } from '@sweep-io/sweep-design/dist/icons/Search';
import { ConfigurationCanvasPanelHeader } from '../../pages/configuration-canvas-panel';
import { useExpandedMode } from '../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { Breadcrumb, Breadcrumbs } from '../selected-object/Breadcrumbs';

export interface DocumentationPageHeaderLayoutProps {
  onCloseDialog?: () => void;
  withExpandedModeButton: boolean;
  title?: string;
  breadcrumbs?: Breadcrumb[];
  showBreadcrumbs?: boolean;
  showSearch?: boolean;
  onSearchClick?: () => void;
  searchLabel?: string;
  searchContent?: ReactNode;
}

export const DocumentationPageHeaderLayout = ({
  onCloseDialog,
  withExpandedModeButton,
  title = 'Documentation',
  breadcrumbs,
  showBreadcrumbs = false,
  showSearch = false,
  onSearchClick,
  searchLabel = 'Search all metadata',
  searchContent,
}: DocumentationPageHeaderLayoutProps) => {
  const { isExpandedMode, isCanvasUnited } = useExpandedMode();

  return (
    <ConfigurationCanvasPanelHeader
      onClose={onCloseDialog}
      withExpandedModeButton={!!withExpandedModeButton}
    >
      {searchContent}

      <Stack direction="row" alignItems="flex-start" gap={0} width="100%">
        {showBreadcrumbs && breadcrumbs && breadcrumbs.length > 1 ? (
          <Breadcrumbs breadcrumbList={breadcrumbs} />
        ) : (
          <Typography variant={isExpandedMode ? 'h2' : 'h4-medium'}>{title}</Typography>
        )}

        {showSearch && onSearchClick && (
          <>
            <Box sx={{ flex: 1 }} />
            {isExpandedMode ? (
              <Box
                sx={{
                  alignSelf: 'center',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: isCanvasUnited ? '5px' : '0px',
                }}
              >
                <Button
                  variant="system"
                  startIconName="Search"
                  size={isCanvasUnited ? 'tiny' : 'small'}
                  onClick={onSearchClick}
                >
                  {searchLabel}
                </Button>
              </Box>
            ) : (
              <IconButton
                size={isCanvasUnited ? 'tiny' : 'small'}
                variant="flat"
                onClick={onSearchClick}
              >
                <Search />
              </IconButton>
            )}
          </>
        )}
      </Stack>
    </ConfigurationCanvasPanelHeader>
  );
};
